export default {
  'nav.catalog': 'Katalog', 'nav.live': 'Kelas Langsung', 'nav.qa': 'Tanya Pakar',
  'nav.consult': 'Konsultasi', 'nav.providers': 'Lembaga', 'nav.myLearning': 'Belajar Saya',
  'nav.certificates': 'Sertifikat', 'nav.orders': 'Transaksi', 'nav.bookings': 'Jadwal Saya',
  'nav.admin': 'Portal Admin', 'nav.verify': 'Verifikasi Sertifikat',
  'auth.login': 'Masuk', 'auth.loginWith': 'Masuk dengan The Muslim', 'auth.logout': 'Keluar',
  'auth.subtitle': 'Gunakan akun The Muslim Anda. Tidak perlu daftar ulang.',
  'auth.ssoContinue': 'Masuk dengan The Muslim',
  'auth.ssoHint': 'Anda akan dibawa ke halaman The Muslim. Belum punya akun? Bisa daftar di sana.',
  'auth.cbWorking': 'Menyelesaikan login…',
  'auth.cbFailed': 'Login tidak selesai',
  'auth.cbMissing': 'Tautan kembali tidak lengkap. Silakan masuk lagi.',
  'auth.cbHome': 'Ke beranda',
  'hero.eyebrow': 'Platform yang menghubungkan orang awam dengan pakar yang sahih',
  'hero.title': 'Belajar langsung dari pakar yang sudah diverifikasi',
  'hero.sub': 'E-course terstruktur, kelas langsung, tanya pakar, dan konsultasi privat — satu tempat, satu akun.',
  'hero.cta': 'Jelajahi katalog', 'hero.cta2': 'Lihat kelas gratis',
  'stat.learners': 'peserta belajar', 'stat.courses': 'kelas terbit', 'stat.experts': 'pakar terverifikasi', 'stat.certificates': 'sertifikat terbit',
  'home.categories': 'Telusuri per bidang', 'home.popular': 'Paling diminati', 'home.featured': 'Pilihan kurator',
  'home.free': 'Mulai gratis', 'home.providers': 'Lembaga mitra', 'home.experts': 'Pakar terverifikasi',
  'home.live': 'Sedang & akan berlangsung', 'home.seeAll': 'Lihat semua',
  'home.trust1': 'Pakar sahih & terverifikasi', 'home.trust1d': 'Setiap pakar melalui verifikasi kredensial sebelum bergabung.',
  'home.trust2': 'Mudah diakses', 'home.trust2d': 'Bertanya langsung ke ahlinya, tanpa ribet.',
  'home.trust3': 'Jawaban terpercaya', 'home.trust3d': 'Rujukan datang dari pakar di bidangnya, bukan sekadar opini.',
  'catalog.title': 'Katalog kelas', 'catalog.filters': 'Filter', 'catalog.reset': 'Reset',
  'catalog.results': 'kelas ditemukan', 'catalog.sort': 'Urutkan', 'catalog.search': 'Cari kelas, pakar, atau topik',
  'filter.category': 'Bidang', 'filter.level': 'Tingkat', 'filter.price': 'Harga', 'filter.rating': 'Rating',
  'filter.language': 'Bahasa', 'filter.features': 'Fitur', 'filter.provider': 'Lembaga',
  'level.beginner': 'Pemula', 'level.intermediate': 'Menengah', 'level.advanced': 'Lanjutan', 'level.expert': 'Lanjutan', 'level.all': 'Semua tingkat',
  'price.free': 'Gratis', 'price.paid': 'Berbayar', 'sort.most_popular': 'Paling diminati',
  'sort.highest_rated': 'Rating tertinggi', 'sort.newest': 'Terbaru', 'sort.price_low': 'Harga terendah', 'sort.price_high': 'Harga tertinggi',
  'feat.certificate': 'Sertifikat', 'feat.quiz': 'Kuis', 'feat.live': 'Sesi live',
  'course.enroll': 'Daftar sekarang', 'course.enrollFree': 'Ikuti gratis', 'course.continue': 'Lanjut belajar',
  'course.buy': 'Beli kelas', 'course.preview': 'Cicip gratis', 'course.objectives': 'Yang akan Anda kuasai',
  'course.curriculum': 'Silabus', 'course.requirements': 'Yang perlu disiapkan', 'course.audience': 'Untuk siapa',
  'course.about': 'Tentang kelas', 'course.instructor': 'Pengajar', 'course.reviews': 'Ulasan',
  'course.related': 'Kelas serupa', 'course.lessons': 'lesson', 'course.modules': 'modul',
  'course.includes': 'Termasuk', 'course.lifetime': 'Akses selamanya', 'course.expiry': 'Akses {n} hari',
  'course.enrolled': '{n} peserta', 'course.lastUpdate': 'Diperbarui {d}', 'course.locked': 'Terkunci',
  'checkout.title': 'Ringkasan pembayaran', 'checkout.coupon': 'Kode kupon', 'checkout.apply': 'Terapkan',
  'checkout.pay': 'Bayar sekarang', 'checkout.method': 'Metode pembayaran', 'checkout.total': 'Total bayar',
  'checkout.subtotal': 'Subtotal', 'checkout.discount': 'Diskon', 'checkout.simulate': 'Simulasi Midtrans Snap',
  'checkout.success': 'Pembayaran berhasil', 'checkout.startLearning': 'Mulai belajar',
  'learn.title': 'Belajar Saya', 'learn.inProgress': 'Sedang berjalan', 'learn.completed': 'Selesai',
  'learn.notStarted': 'Belum dimulai', 'learn.resume': 'Lanjutkan', 'learn.progress': '{n}% selesai',
  'player.next': 'Lesson berikutnya', 'player.prev': 'Sebelumnya', 'player.complete': 'Tandai selesai',
  'player.previewNote': 'Anda sedang mencicipi kelas ini secara gratis. Pelajaran lain terbuka setelah mendaftar.', 'player.previewCta': 'Lihat kelas', 'player.otherLang': 'Video dalam bahasa {lang}',
  'player.notes': 'Catatan', 'player.resources': 'Materi', 'player.transcript': 'Transkrip', 'player.discussion': 'Diskusi',
  'player.speed': 'Kecepatan', 'player.captions': 'Teks', 'player.resume': 'Lanjut dari {t}',
  // --- ruang belajar (halaman /learn) ---
  'player.exit': 'Keluar', 'player.lessonOf': 'Pelajaran {n} dari {total}',
  'player.remaining': 'Sisa {t} materi', 'player.shortcutHint': 'spasi jeda · ←→ 5 dtk · J/L 10 dtk · F layar penuh',
  'player.videoMissing': 'Video pelajaran ini belum diunggah.',
  'player.videoBroken': 'Video pelajaran ini ada, tapi tautannya gagal dibuat. Coba muat ulang halaman.',
  'player.tamper': 'Lapisan penanda pemilik dilepas, jadi pemutaran dihentikan. Muat ulang halaman untuk menonton lagi.',
  'player.throttled': 'Terlalu banyak permintaan video dari akun ini dalam satu jam. Coba lagi sebentar lagi.',
  'player.linkDead': 'Tautan video tidak bisa diperbarui. Periksa koneksi Anda, lalu muat ulang halaman.',
  'player.nextUp': 'Berikutnya', 'player.lastLesson': 'Ini pelajaran terakhir.', 'player.replay': 'Ulangi',
  'player.markedDone': 'Pelajaran ditandai selesai',
  'player.liveNote': 'Sesi langsung untuk peserta kelas ini. Tautan aktif 10 menit sebelum jadwal.',
  'player.liveCta': 'Lihat jadwal live',
  'player.noteAdd': 'Simpan catatan', 'player.notePlaceholder': 'Tulis catatan Anda untuk pelajaran ini…',
  'player.notePlaceholderAt': 'Tulis catatan untuk menit {t}…',
  'player.notesEmpty': 'Belum ada catatan. Yang Anda tulis di sini tersimpan di akun Anda, jadi tetap ada saat dibuka dari perangkat lain.',
  'player.notesLoginTitle': 'Catatan tersimpan di akun Anda',
  'player.notesLoginHint': 'Masuk dulu supaya catatan Anda tidak hilang saat ganti perangkat.',
  'player.jumpTo': 'Lompat ke menit ini',
  'player.resourcesEmpty': 'Tidak ada materi unduhan di pelajaran ini.',
  'player.download': 'Unduh', 'player.linkFailed': 'Tautan gagal dibuat',
  'player.courseDone': 'Kelas selesai! 🎉',
  'player.courseDoneNote': 'Sertifikat Anda sudah terbit dan bisa diverifikasi publik lewat kode unik.',
  'player.viewCert': 'Lihat sertifikat',
  'ui.edit': 'Ubah', 'ui.delete': 'Hapus',
  'adm.res.title': 'Materi unduhan', 'adm.res.add': 'Tambah materi',
  'adm.res.added': 'Materi ditambahkan',
  'adm.res.tooBig': 'Ukuran file maksimal 25 MB.',
  'adm.res.hint': 'Lampirkan slide, lembar kerja, atau ringkasan. PDF atau gambar, maksimal 25 MB. Ekspor slide ke PDF dulu.',
  'quiz.start': 'Mulai kuis', 'quiz.submit': 'Kumpulkan', 'quiz.retry': 'Coba lagi',
  'quiz.passed': 'Lulus', 'quiz.failed': 'Belum lulus', 'quiz.score': 'Nilai', 'quiz.attempt': 'Percobaan {n}',
  'cert.title': 'Sertifikat Saya', 'cert.download': 'Unduh PDF', 'cert.share': 'Bagikan ke LinkedIn',
  'cert.verify': 'Verifikasi', 'cert.serial': 'Nomor seri', 'cert.issued': 'Diterbitkan',
  'cert.valid': 'Sertifikat ini sah dan terdaftar', 'cert.invalid': 'Sertifikat tidak ditemukan',
  'cert.verifyTitle': 'Verifikasi sertifikat', 'cert.verifyHint': 'Masukkan kode verifikasi yang tercetak di sertifikat',
  'qa.title': 'Tanya Pakar', 'qa.ask': 'Ajukan pertanyaan', 'qa.answered': 'Terjawab', 'qa.open': 'Menunggu jawaban',
  'qa.yourQuestion': 'Pertanyaan Anda', 'qa.detail': 'Detail pertanyaan', 'qa.send': 'Kirim pertanyaan',
  'qa.sub': 'Kirim pertanyaan ke pakar terverifikasi. Gratis di v1 — jawaban terbuka untuk umum agar bermanfaat bagi yang lain.',
  'qa.field': 'Bidang', 'qa.askWho': 'Tanya siapa', 'qa.anyExpert': 'Pakar mana saja di bidang ini',
  'qa.askWhoHint': 'Kosongkan bila tidak menuju pakar tertentu — pertanyaan terbuka biasanya lebih cepat dijawab.',
  'qa.field.title': 'Pertanyaan singkat', 'qa.field.titlePh': 'Contoh: Bagaimana hukum…?',
  'qa.field.body': 'Penjelasan', 'qa.field.bodyHint': 'Semakin detail, semakin tepat jawabannya',
  'qa.publicNote': 'Pertanyaan yang dijawab akan tampil publik tanpa data pribadi Anda.',
  'qa.sent': 'Pertanyaan terkirim — pakar akan menjawab 1–3 hari kerja.',
  'live.title': 'Kelas Langsung', 'live.now': 'Sedang live', 'live.upcoming': 'Akan datang', 'live.ended': 'Selesai',
  'live.join': 'Masuk kelas', 'live.remind': 'Ingatkan saya', 'live.reminded': 'Pengingat aktif', 'live.viewers': '{n} menonton',
  'consult.title': 'Konsultasi 1-on-1', 'consult.book': 'Pilih jadwal', 'consult.slots': '{n} slot tersedia',
  'consult.from': 'Mulai', 'consult.confirm': 'Konfirmasi booking', 'consult.notes': 'Ceritakan singkat kebutuhan Anda',
  'admin.dashboard': 'Dashboard', 'admin.guide': 'Panduan', 'admin.courses': 'Kelas', 'admin.instructors': 'Pakar',
  'admin.live': 'Kelas Langsung', 'admin.qa': 'Tanya Pakar', 'admin.consult': 'Konsultasi',
  'admin.enrollments': 'Pendaftaran', 'admin.reviews': 'Ulasan', 'admin.earnings': 'Pendapatan',
  'admin.slots': 'Slot Konsultasi', 'admin.certificates': 'Sertifikat', 'admin.coupons': 'Kupon',
  'admin.notifications': 'Notifikasi', 'admin.certTemplates': 'Template Sertifikat', 'admin.audit': 'Audit Log',
  'admin.providers': 'Provider', 'admin.categories': 'Kategori', 'admin.payouts': 'Payout',
  'admin.platformOnly': 'Khusus platform', 'admin.approvalQueue': 'Menunggu kurasi',
  'admin.selected': '{n} dipilih', 'admin.approve': 'Setujui', 'admin.reject': 'Tolak', 'admin.archive': 'Arsipkan',
  'admin.bulk': 'Aksi massal', 'admin.newCourse': 'Kelas baru', 'admin.editCurriculum': 'Atur kurikulum',
  'status.draft': 'Draf', 'status.pending_review': 'Menunggu kurasi', 'status.published': 'Terbit',
  'status.rejected': 'Ditolak', 'status.archived': 'Diarsipkan', 'status.active': 'Aktif', 'status.completed': 'Selesai',
  'status.paid': 'Dibayar', 'status.pending': 'Tertunda', 'status.failed': 'Gagal', 'status.held': 'Ditahan',
  'status.payable': 'Siap cair', 'status.processing': 'Diproses',
  'ui.loading': 'Memuat…', 'ui.retry': 'Coba lagi', 'ui.error': 'Ada yang tidak beres',
  'ui.empty': 'Belum ada data', 'ui.emptyHint': 'Coba ubah filter atau kata kunci.',
  'ui.save': 'Simpan', 'ui.cancel': 'Batal', 'ui.close': 'Tutup', 'ui.search': 'Cari',
  'ui.all': 'Semua', 'ui.verified': 'Terverifikasi', 'ui.comingSoon': 'Segera Hadir',
  'ui.page': 'Halaman', 'ui.of': 'dari', 'ui.viewMode': 'Tampilan', 'ui.design': 'Varian desain',

  // ---- portal admin: label yang dipakai lintas-halaman ----
  // Dikumpulkan supaya kolom "Status"/"Pakar"/"Harga" yang muncul di belasan
  // tabel tidak jadi belasan kunci yang harus diterjemahkan satu per satu.
  'adm.col.actions': 'Aksi', 'adm.col.provider': 'Provider', 'adm.col.instructor': 'Pakar',
  'adm.col.status': 'Status', 'adm.col.price': 'Harga', 'adm.col.students': 'Peserta',
  'adm.col.no': 'No.',
  'adm.col.course': 'Kelas', 'adm.col.schedule': 'Jadwal', 'adm.col.time': 'Waktu',
  'adm.col.duration': 'Durasi', 'adm.col.field': 'Bidang', 'adm.col.updated': 'Diperbarui',
  'adm.col.notes': 'Catatan', 'adm.col.position': 'Urutan', 'adm.col.key': 'Key',
  'adm.col.score': 'Nilai', 'adm.col.scope': 'Cakupan',
  'adm.table.clear': 'bersihkan',
  'adm.val.inactive': 'Nonaktif', 'adm.val.platform': 'Platform', 'adm.val.default': 'Default',
  'adm.val.pending': 'Menunggu', 'adm.val.notYet': 'Belum', 'adm.val.yes': 'Ya',
  'adm.val.minutes': '{n} mnt',
  'adm.lang.id': 'Indonesia', 'adm.lang.en': 'English', 'adm.lang.ms': 'Melayu', 'adm.lang.ar': 'Arab',
  'adm.field.category': 'Kategori', 'adm.field.priceIdr': 'Harga (IDR)', 'adm.field.logo': 'Logo',
  'adm.field.accentColor': 'Warna aksen (hex)',
  'adm.field.providerHint': 'Provider admin otomatis memakai lembaganya sendiri.',
  'adm.bulk.activate': 'Aktifkan', 'adm.bulk.deactivate': 'Nonaktifkan',
  'adm.bulk.markComplete': 'Tandai selesai', 'adm.bulk.approvePublish': 'Setujui & terbitkan',
  'adm.bulk.unpublish': 'Jadikan draf',
  'adm.bulk.updated': '{n} baris diperbarui', 'adm.bulk.rejected': '{n} baris ditolak',
  'adm.filter.all': '{field}: Semua',

  // ---- portal admin: form generik (ResourcePage) ----
  'adm.form.required': '{field} wajib diisi', 'adm.form.selectField': '— Pilih {field} —',
  'adm.form.optionsFailed': 'Gagal memuat pilihan', 'adm.form.saved': 'Perubahan disimpan',
  'adm.form.created': 'Berhasil ditambahkan', 'adm.form.saveFailed': 'Gagal menyimpan',
  'adm.form.deleted': 'Data dihapus', 'adm.form.deleteFailed': 'Gagal menghapus',
  'adm.form.edit': 'Edit', 'adm.form.add': 'Tambah', 'adm.form.delete': 'Hapus',
  'adm.form.deleteTitle': 'Konfirmasi hapus',
  'adm.form.deleteDefault': 'Hapus data ini? Tindakan ini bisa dibatalkan lewat DB (soft delete).',
  'adm.reject.title': 'Alasan penolakan', 'adm.reject.confirmN': 'Tolak {n} kelas',
  'adm.reject.note': 'Alasan dikirim ke provider dan tampil di portal mereka. Jelaskan yang perlu diperbaiki.',
  'adm.reject.ph': 'Mis. audio modul 2 pecah di menit 04:12 — mohon rekam ulang.',

  // ---- portal admin: kelas ----
  'adm.courses.sub': 'Kurasi, terbitkan, dan atur kurikulum kelas.',
  'adm.courses.add': 'Tambah Kelas', 'adm.courses.createTitle': 'Tambah Kelas Baru',
  'adm.courses.createdMsg': 'Kelas dibuat sebagai draf — lengkapi kurikulum lalu ajukan kurasi.',
  'adm.courses.formSub': 'Buat kerangka kelas dulu (status draf). Kurikulum, modul, kuis & harga detail diatur di editor kelas.',
  'adm.courses.newCourseToast': 'Form kelas baru: POST /admin/courses',
  'adm.courses.field.title': 'Judul kelas', 'adm.courses.field.titlePh': 'mis. Tahsin Al-Qur’an untuk Pemula',
  'adm.courses.field.subtitle': 'Subjudul', 'adm.courses.field.subtitlePh': 'Tampil di kartu & hero',
  'adm.courses.field.instructor': 'Pakar pengajar',
  'adm.courses.field.instructorHint': 'Harus pakar dari provider yang sama.',
  'adm.courses.field.categoryHint': 'Kosongkan untuk ikut bidang pakar.',
  'adm.courses.field.isFree': 'Kelas gratis',
  'adm.courses.field.minutes': 'Estimasi durasi (menit)',
  'adm.courses.field.desc': 'Deskripsi singkat', 'adm.courses.field.descPh': 'Ringkas isi & manfaat kelas…',
  'adm.courses.lessonModules': '{l} lesson · {m} modul',
  'adm.courses.manage': 'Kelola',

  // ---- portal admin: pakar ----
  'adm.instructors.sub': 'Verifikasi kredensial pakar — nilai jual utama platform.',
  'adm.instructors.add': 'Tambah Pakar', 'adm.instructors.createTitle': 'Tambah Pakar Baru',
  'adm.instructors.editTitle': 'Edit Pakar',
  'adm.instructors.formSub': 'Isi profil pakar. Bidang & provider menentukan di mana pakar tampil.',
  'adm.instructors.deleteConfirm': 'Hapus pakar "{name}"? Data disembunyikan (soft delete), bisa dipulihkan lewat DB.',
  'adm.instructors.field.avatar': 'Foto profil',
  'adm.instructors.field.name': 'Nama lengkap', 'adm.instructors.field.namePh': 'mis. Ustadz Ahmad Fauzi, Lc.',
  'adm.instructors.field.headline': 'Headline', 'adm.instructors.field.headlinePh': 'Pakar Tajwid & Qiraat Sab’ah',
  'adm.instructors.field.category': 'Bidang keahlian',
  'adm.instructors.field.bio': 'Bio singkat',
  'adm.instructors.field.bioPh': 'Latar belakang, pengalaman mengajar, dan pendekatan materi…',
  'adm.instructors.field.verified': 'Tandai terverifikasi',
  'adm.instructors.filterVerified': 'Verifikasi', 'adm.instructors.unverify': 'Cabut verifikasi',
  'adm.i18n.sectionTitle': 'Teks berbahasa',
  'adm.i18n.sectionHint': 'Hanya isi kotak ini yang punya versi per bahasa. Foto, nama, dan medan di atas cuma ada satu.',
  'adm.i18n.sourceLang': 'Bahasa asli tulisan',
  'adm.i18n.sourceHint': 'Bahasa yang Anda pakai menulis di kolom bawah. Terjemahan dibuat dari sini, jadi pastikan ini benar.',
  'adm.i18n.sourceBadge': '(asli)',
  'adm.i18n.translate': 'Terjemahkan dengan AI',
  'adm.i18n.saveFirst': 'Simpan dulu, baru bisa diterjemahkan.',
  'adm.i18n.translateTo': 'Terjemahkan ke {lang} dengan AI',
  'adm.i18n.pickTab': 'Pilih tab bahasa tujuan dulu.',
  'adm.i18n.done': 'Terjemahan selesai.',
  'adm.i18n.failed': 'Terjemahan gagal. Coba lagi sebentar lagi.',
  'adm.i18n.partial': 'Sebagian bahasa gagal diterjemahkan. Coba lagi untuk yang masih kosong.',
  'adm.i18n.nothing': 'Tidak ada yang perlu diterjemahkan — semuanya sudah terisi.',
  'adm.i18n.fromAI': 'Hasil AI — silakan periksa dan betulkan bila perlu.',
  'adm.i18n.edited': 'Sudah disunting manual. Tidak akan ditimpa terjemahan ulang.',
  'adm.i18n.empty': 'Belum ada terjemahan. Kosong berarti teks asli yang dipakai.',
  'adm.instructors.field.accountEmail': 'Akun login (email)',
  'adm.instructors.field.accountEmailPh': 'alamat@kampus.edu.my',
  'adm.instructors.account.hintNew': 'Isi untuk membuatkan akun. Pakar lalu daftar di The Muslim dengan alamat yang sama.',
  'adm.instructors.account.hintNone': 'Belum punya akun — pakar ini belum bisa masuk. Isi emailnya untuk membuatkan.',
  'adm.instructors.account.hintWaiting': 'Akun sudah dibuat. Pakar tinggal daftar di The Muslim dengan alamat ini, lalu verifikasi emailnya.',
  'adm.instructors.account.hintLinked': 'Sudah pernah masuk. Mengosongkan kolom ini tidak memutus apa pun.',
  'adm.instructors.account.hintMissing': 'Tautan menggantung: akunnya sudah tidak ada. Isi email baru untuk menyambungkan ulang.',
  'adm.instructors.col.account': 'Akun',
  'adm.instructors.account.none': 'Belum ada akun',
  'adm.instructors.account.waiting': 'Menunggu daftar',
  'adm.instructors.account.linked': 'Aktif',
  'adm.instructors.account.missing': 'Tautan rusak',
  'adm.instructors.col.credentials': 'Kredensial',

  // ---- portal admin: kelas langsung ----
  'adm.live.sub': 'Jadwalkan sesi LiveKit, pantau penonton.',
  'adm.live.col.session': 'Sesi', 'adm.live.col.viewers': 'Penonton',
  'adm.live.col.ticket': 'Tiket', 'adm.live.col.room': 'Room',

  // ---- portal admin: tanya pakar ----
  'adm.qa.sub': 'Antrean pertanyaan yang menunggu jawaban pakar.',
  'adm.qa.col.question': 'Pertanyaan', 'adm.qa.col.addressed': 'Ditujukan',
  'adm.qa.col.received': 'Masuk', 'adm.qa.col.answers': 'Jawaban',
  'adm.qa.answerTitle': 'Jawab pertanyaan', 'adm.qa.answerSend': 'Kirim jawaban',
  'adm.qa.answerSent': 'Jawaban terkirim', 'adm.qa.answerLabel': 'Jawaban pakar',
  'adm.qa.answerPh': 'Tulis jawaban dengan rujukan yang bisa diverifikasi…',
  'adm.qa.answerNote': 'Jawaban langsung tampil publik dan memicu notifikasi ke penanya.',

  // ---- portal admin: konsultasi & pendaftaran ----
  'adm.consult.sub': 'Booking sesi 1-on-1 dan statusnya.',
  'adm.consult.confirm': 'Konfirmasi', 'adm.consult.cancel': 'Batalkan',
  'adm.enroll.sub': 'Siapa belajar apa, sejauh mana.',
  'adm.enroll.reactivate': 'Aktifkan lagi', 'adm.enroll.revoke': 'Cabut akses',
  'adm.enroll.col.source': 'Sumber', 'adm.enroll.col.progress': 'Progress',
  'adm.enroll.col.enrolledAt': 'Terdaftar',

  // ---- portal admin: ulasan ----
  'adm.reviews.sub': 'Moderasi ulasan; sembunyikan yang melanggar.',
  'adm.reviews.filterStars': 'Bintang', 'adm.reviews.hide': 'Sembunyikan', 'adm.reviews.show': 'Tampilkan',
  'adm.reviews.col.author': 'Penulis', 'adm.reviews.col.text': 'Ulasan',

  // ---- portal admin: provider ----
  'adm.providers.sub': 'Tenant yang menjual kelas. Platform-only.',
  'adm.providers.add': 'Tambah Provider', 'adm.providers.createTitle': 'Tambah Provider Baru',
  'adm.providers.editTitle': 'Edit Provider',
  'adm.providers.formSub': 'Onboard lembaga/perusahaan baru sebagai penjual kelas. Slug dibuat otomatis dari nama.',
  'adm.providers.field.cover': 'Sampul',
  'adm.providers.field.name': 'Nama provider', 'adm.providers.field.namePh': 'mis. Rumah Tahfizh Nusantara',
  'adm.providers.field.desc': 'Deskripsi', 'adm.providers.field.descPh': 'Profil singkat lembaga…',
  'adm.providers.field.website': 'Website', 'adm.providers.field.email': 'Email kontak',
  'adm.providers.field.emailPh': 'admin@lembaga.id',
  'adm.providers.field.share': 'Bagi hasil provider (%)',
  'adm.providers.field.shareHint': 'Porsi provider dari harga; sisanya untuk platform.',
  'adm.providers.field.locale': 'Locale default',
  'adm.providers.verify': 'Verifikasi',
  'adm.providers.col.share': 'Bagi hasil', 'adm.providers.col.locale': 'Locale',

  // ---- portal admin: kategori ----
  'adm.categories.sub': 'Taksonomi platform-level (15 bidang).',
  'adm.categories.add': 'Tambah Kategori', 'adm.categories.editTitle': 'Edit Kategori',
  'adm.categories.formSub': 'Bidang keahlian platform. Key dipakai di URL & filter — kosongkan untuk auto dari nama.',
  'adm.categories.deleteConfirm': 'Hapus kategori "{name}"? Disembunyikan (soft delete).',
  'adm.categories.field.nameId': 'Nama (Indonesia)', 'adm.categories.field.nameIdPh': 'mis. Tahsin & Tajwid',
  'adm.categories.field.nameEn': 'Nama (English)', 'adm.categories.field.nameMs': 'Nama (Melayu)',
  'adm.categories.field.nameAr': 'Nama (Arab)',
  'adm.categories.field.keyPh': 'tahsin-tajwid (opsional)',
  'adm.categories.field.keyHint': 'Slug unik; auto dari nama bila kosong.',
  'adm.categories.field.icon': 'Icon (Material Symbols)',
  'adm.categories.col.accent': 'Accent',
  // ---- portal admin: payout ----
  'adm.payouts.sub': 'Transfer bagi-hasil ke provider per periode.',
  'adm.payouts.markPaid': 'Tandai sudah dibayar',
  'adm.payouts.col.period': 'Periode', 'adm.payouts.col.amount': 'Jumlah', 'adm.payouts.col.method': 'Metode',

  // ---- portal admin: kupon ----
  'adm.coupons.sub': 'Kode diskon: persentase / potongan tetap, batas pakai, dan masa berlaku.',
  'adm.coupons.add': 'Tambah Kupon', 'adm.coupons.editTitle': 'Edit Kupon',
  'adm.coupons.formSub': 'Kode di-uppercase otomatis. Nilai = persen (0–100) untuk tipe persen, atau rupiah untuk potongan tetap.',
  'adm.coupons.deleteConfirm': 'Hapus kupon "{code}"? Disembunyikan (soft delete).',
  'adm.coupons.field.code': 'Kode kupon', 'adm.coupons.field.type': 'Tipe',
  'adm.coupons.type.percent': 'Persentase (%)', 'adm.coupons.type.fixed': 'Potongan tetap (Rp)',
  'adm.coupons.field.value': 'Nilai',
  'adm.coupons.scope.all': 'Semua kelas', 'adm.coupons.scope.course': 'Kelas tertentu',
  'adm.coupons.scope.category': 'Kategori tertentu',
  'adm.coupons.field.maxUses': 'Maks. total pakai', 'adm.coupons.field.maxUsesHint': '0 = tanpa batas.',
  'adm.coupons.field.perUser': 'Maks. per user',
  'adm.coupons.field.startsAt': 'Mulai berlaku', 'adm.coupons.field.endsAt': 'Berakhir',
  'adm.coupons.field.providerHint': 'Kosongkan untuk kupon seluruh platform.',
  'adm.coupons.col.code': 'Kode', 'adm.coupons.col.discount': 'Diskon',
  'adm.coupons.col.used': 'Terpakai', 'adm.coupons.col.valid': 'Berlaku',

  // ---- portal admin: slot konsultasi ----
  'adm.slots.sub': 'Slot waktu konsultasi 1-on-1 yang dibuka pakar untuk dibooking.',
  'adm.slots.add': 'Tambah Slot', 'adm.slots.createTitle': 'Buka Slot Konsultasi',
  'adm.slots.editTitle': 'Edit Slot',
  'adm.slots.formSub': 'Provider slot otomatis ikut provider pakar. Slot yang sudah dibooking tidak bisa dibuka ulang di sini.',
  'adm.slots.deleteConfirm': 'Hapus slot ini? Disembunyikan (soft delete).',
  'adm.slots.field.start': 'Waktu mulai', 'adm.slots.field.duration': 'Durasi (menit)',
  'adm.slots.field.priceHint': '0 = gratis.',
  'adm.slots.open': 'Buka', 'adm.slots.col.booked': 'Booking',
  'adm.slots.booked': 'Dibooking', 'adm.slots.free': 'Kosong',

  // ---- portal admin: sertifikat ----
  'adm.certs.sub': 'Sertifikat yang telah diterbitkan; cabut atau terbitkan ulang bila perlu.',
  'adm.certs.reissue': 'Terbitkan ulang', 'adm.certs.revoke': 'Cabut',
  'adm.certs.col.issued': 'Terbit', 'adm.certs.col.code': 'Kode verifikasi',
  'adm.certTpl.sub': 'Desain sertifikat: logo, warna, tanda tangan, dan teks isi.',
  'adm.certTpl.add': 'Tambah Template', 'adm.certTpl.createTitle': 'Tambah Template Sertifikat',
  'adm.certTpl.editTitle': 'Edit Template',
  'adm.certTpl.formSub': 'Gunakan {student}, {course}, {date} di teks isi sebagai placeholder yang diganti saat penerbitan.',
  'adm.certTpl.deleteConfirm': 'Hapus template "{name}"? Disembunyikan (soft delete).',
  'adm.certTpl.field.name': 'Nama template', 'adm.certTpl.field.namePh': 'mis. Sertifikat Tahsin 2026',
  'adm.certTpl.field.providerHint': 'Kosongkan untuk template platform.',
  'adm.certTpl.field.orientation': 'Orientasi',
  'adm.certTpl.orientation.landscape': 'Landscape', 'adm.certTpl.orientation.portrait': 'Portrait',
  'adm.certTpl.field.signature': 'Tanda tangan',
  'adm.certTpl.field.signName': 'Nama penandatangan', 'adm.certTpl.field.signTitle': 'Jabatan penandatangan',
  'adm.certTpl.field.signNamePh': 'Ustadz Ahmad Fauzi, Lc.',
  'adm.certTpl.field.signTitlePh': 'Direktur Akademik',
  'adm.certTpl.field.body': 'Teks isi',
  'adm.certTpl.field.bodyPh': 'Diberikan kepada {student} atas penyelesaian {course}…',
  'adm.certTpl.field.isDefault': 'Jadikan default',
  'adm.certTpl.col.template': 'Template', 'adm.certTpl.col.signer': 'Penandatangan',

  // ---- portal admin: audit log ----
  'adm.audit.sub': 'Jejak aksi admin (create/update/hapus/broadcast). Sumber: activity log.',
  'adm.audit.col.action': 'Aksi', 'adm.audit.col.actor': 'Oleh', 'adm.audit.col.detail': 'Detail',

  // ---- editor kelas ----
  'adm.course.tabDetail': 'Detail', 'adm.course.tabPricing': 'Harga & akses',
  'adm.course.tabSettings': 'Sertifikat',
  'adm.course.viewPublic': 'Lihat publik', 'adm.course.preview': 'Pratinjau isi', 'adm.course.previewEmpty': 'Belum ada pelajaran untuk dipratinjau', 'adm.course.submitReview': 'Ajukan kurasi',
  'adm.course.published': 'Kelas diterbitkan', 'adm.course.rejected': 'Kelas ditolak',
  'adm.course.rejectedBy': 'Ditolak kurator', 'adm.course.rejectBtn': 'Tolak kelas',
  'adm.course.rejectPh': 'Jelaskan yang perlu diperbaiki provider…',
  'adm.course.title': 'Judul', 'adm.course.estMinutes': 'Estimasi menit',
  'adm.course.spokenLang': 'Bahasa pengantar',
  'adm.course.spokenLangHint': 'Bahasa yang dipakai pengajar di video. Tidak ikut diterjemahkan.',
  'adm.course.descHtml': 'Deskripsi (HTML)', 'adm.course.objectives': 'Tujuan belajar',
  'adm.course.addObjective': 'Tambah poin',
  'adm.course.objectivesHint': 'Apa yang bisa dilakukan murid setelah selesai.',
  'adm.course.objectivesPh': 'Contoh: Menyusun rencana sesi kaunseling untuk klien remaja',
  'adm.course.addRequirement': 'Tambah persiapan',
  'adm.course.requirementsHint': 'Barang atau bekal yang perlu disiapkan murid. Ini tidak mengunci kelas — yang mengunci ada di Prasyarat kelas, tepat di bawah.',
  'adm.course.requirementsPh': 'Contoh: Sudah pernah mengikuti kelas dasar kaunseling',
  'adm.course.addAudience': 'Tambah sasaran',
  'adm.course.audienceHint': 'Siapa yang paling cocok mengikuti kelas ini.',
  'adm.course.audiencePh': 'Contoh: Guru bimbingan konseling di sekolah menengah',
  'adm.course.thumbnail': 'Thumbnail', 'adm.course.thumbHint': 'Rasio 16:9, minimal 1280×720, maks 8 MB.',
  'adm.course.slug': 'Slug', 'adm.course.comparePrice': 'Harga pembanding',
  'adm.course.accessType': 'Tipe akses', 'adm.course.access.lifetime': 'Selamanya',
  'adm.course.access.expiry': 'Kedaluwarsa N hari', 'adm.course.access.subscription': 'Langganan',
  'adm.course.accessDays': 'Akses (hari)',
  'adm.course.certOnComplete': 'Terbitkan sertifikat saat selesai',
  'adm.course.completionRule': 'Completion rule',
  'adm.course.completionRule1': '100% lesson selesai · kuis akhir lulus (nilai ≥ 70)',
  'adm.course.completionRule2': 'Video dianggap selesai pada 90% durasi (SCORM/cmi5: completion ≠ success).',

  // ---- editor kelas: kesiapan ----
  'adm.ready.title': 'Kesiapan kelas', 'adm.ready.count': '{n}/{total} siap',
  'adm.ready.live': 'Kelas ini tayang di storefront.',
  'adm.ready.waiting': 'Menunggu kurasi platform admin',
  'adm.ready.remaining': 'Lengkapi {n} langkah lagi',
  'adm.ready.detail': 'Detail kelas', 'adm.ready.detailDone': 'Deskripsi & objectives lengkap',
  'adm.ready.detailTodo': 'Isi deskripsi + minimal 1 objective',
  'adm.ready.curriculum': 'Kurikulum',
  'adm.ready.curriculumTodo': 'Tambah minimal 1 modul & 1 lesson',
  'adm.ready.quiz': 'Soal kuis', 'adm.ready.quizDone': 'Semua kuis sudah ada soal',
  'adm.ready.quizTodo': '{n} kuis belum ada soal',
  'adm.ready.priceTodo': 'Set harga atau tandai gratis',

  // ---- editor kurikulum ----
  'adm.cur.loading': 'Memuat kurikulum…', 'adm.cur.saved': 'Kurikulum disimpan',
  'adm.cur.addModule': 'Tambah modul', 'adm.cur.addLesson': 'Tambah lesson',
  'adm.cur.moduleN': 'Modul {n}', 'adm.cur.newLesson': 'Lesson baru',
  'adm.cur.count': '{m} modul · {l} lesson',
  'adm.cur.unsaved': 'Belum disimpan', 'adm.cur.save': 'Simpan kurikulum',
  'adm.cur.drip.none': 'Rilis: langsung', 'adm.cur.drip.days': 'Rilis: H+N', 'adm.cur.drip.date': 'Rilis: tanggal',
  'adm.cur.seconds': 'detik', 'adm.cur.preview': 'preview',
  'adm.cur.saveFirst': 'simpan dulu',
  'adm.cur.saveFirstHint': 'Simpan kurikulum dulu agar lesson punya ID',
  'adm.a11y.moveUp': 'naik', 'adm.a11y.moveDown': 'turun', 'adm.a11y.delete': 'hapus',

  // ---- editor kuis ----
  'adm.quiz.title': 'Kelola soal · {lesson}', 'adm.quiz.save': 'Simpan kuis', 'adm.quiz.saved': 'Kuis disimpan',
  'adm.quiz.passing': 'Nilai lulus (%)', 'adm.quiz.timeLimit': 'Batas waktu (menit)',
  'adm.quiz.maxAttempts': 'Maks percobaan',
  'adm.quiz.question': 'Soal', 'adm.quiz.questionPh': 'Tulis pertanyaan…',
  'adm.quiz.deleteQuestion': 'hapus soal', 'adm.quiz.deleteOption': 'hapus opsi',
  'adm.quiz.type': 'Tipe', 'adm.quiz.points': 'Poin',
  'adm.quiz.qtype.single': 'Pilihan tunggal', 'adm.quiz.qtype.multi': 'Pilihan ganda (boleh >1 benar)',
  'adm.quiz.qtype.tf': 'Benar / Salah',
  'adm.quiz.options': 'Opsi jawaban', 'adm.quiz.optionsHint': '(centang yang benar)',
  'adm.quiz.markCorrect': 'tandai benar', 'adm.quiz.optionN': 'Opsi {n}', 'adm.quiz.addOption': 'Tambah opsi',
  'adm.quiz.explanation': 'Penjelasan (opsional)', 'adm.quiz.explanationPh': 'Muncul setelah dijawab',
  'adm.quiz.addQuestion': 'Tambah soal', 'adm.quiz.empty': 'Belum ada soal. Klik “Tambah soal”.',
  'adm.quiz.err.noText': 'Ada soal tanpa teks pertanyaan',
  'adm.quiz.err.minOptions': 'Tiap soal minimal 2 opsi jawaban',
  'adm.quiz.err.emptyOption': 'Ada opsi jawaban kosong',
  'adm.quiz.err.noCorrect': 'Tiap soal minimal 1 jawaban benar',

  // ---- dasbor admin ----
  'adm.dash.period': 'Periode {label}.', 'adm.dash.loading': 'Memuat ringkasan…', 'adm.dash.export': 'Export',
  'adm.dash.guideTitle': 'Baru di sini? Mulai dari panduan.',
  'adm.dash.guideSub': 'Urutan mengisi konten, kolom yang wajib, dan jebakan yang sering bikin kelas gagal diajukan.',
  'adm.dash.guideCta': 'Buka panduan',
  'adm.dash.enrollments': 'Pendaftaran',
  'adm.dash.lessonsDone': 'Lesson selesai (North Star)', 'adm.dash.lessonsHint': 'Indikator nilai belajar nyata',
  'adm.dash.certsIssued': 'Sertifikat terbit',
  'adm.dash.funnelTitle': 'Funnel pembelian', 'adm.dash.funnelRange': '{first} → bayar',
  'adm.dash.funnelConversion': 'Konversi akhir',
  'adm.dash.funnelNoVisits': 'Kunjungan belum tercatat bulan ini, jadi persentase konversi belum bisa dihitung. Pencatatan berjalan otomatis begitu ada pengunjung membuka katalog.',
  'adm.dash.funnelEmpty': 'Belum ada kunjungan katalog bulan ini. Kunjungan mulai tercatat begitu ada yang membuka halaman kelas — kunjungan admin sendiri sengaja tidak dihitung.',
  'adm.dash.queueAll': 'Semua antrean', 'adm.dash.queueClean': 'Antrean bersih 🎉',
  'adm.dash.submitted': 'Diajukan {ago}', 'adm.dash.lessonCount': '{n} lesson', 'adm.dash.reviewCta': 'Tinjau',
  'adm.dash.topCourses': 'Kelas terlaris', 'adm.dash.enrollCount': '{n} pendaftaran',
  'adm.dash.topCoursesEmpty': 'Belum ada kelas yang punya pendaftar. Daftar ini terisi sendiri begitu kelas pertama diikuti seseorang.',
  'adm.dash.health': 'Kesehatan platform', 'adm.dash.payoutsWaiting': 'Payout menunggu',
  'adm.dash.reviewsToCheck': 'Ulasan perlu ditinjau',
  'adm.dash.recentOrders': 'Order terbaru', 'adm.dash.orderNoItems': '(tanpa rincian item)',
  'adm.dash.ordersEmpty': 'Belum ada order masuk.',
  'adm.dash.csv.metric': 'Metrik', 'adm.dash.csv.value': 'Nilai', 'adm.dash.csv.period': 'Periode',
  'adm.dash.csv.gmv': 'GMV', 'adm.dash.csv.lessonsDone': 'Lesson selesai',
  'adm.dash.csv.month': 'Bulan', 'adm.dash.csv.funnelStage': 'Tahap corong',
  'adm.dash.csv.count': 'Jumlah', 'adm.dash.csv.revenue': 'Pendapatan',

  // ---- kerangka portal admin ----
  'adm.gate.title': 'Portal Admin KnoWledgeX',
  'adm.gate.sub': 'Masuk dengan akun admin platform atau admin provider, memakai email & password yang diberikan tim teknis.',
  'adm.gate.login': 'Masuk sebagai admin', 'adm.gate.storefront': 'Ke storefront',
  'adm.role.platform': 'Admin platform', 'adm.role.provider': 'Admin provider',
  'adm.scope.all': 'Semua provider', 'adm.scope.provider': 'Scope: {name}',
  'adm.nav.storefront': 'Storefront',

  // ---- daftar langkah onboarding ----
  'adm.onb.fabTitle': 'Langkah awal untuk pakar baru', 'adm.onb.fabLabel': 'Langkah awal — {n} langkah tersisa',
  'adm.onb.fabTip': 'Langkah awal',
  'adm.onb.panelTitle': 'Mulai dari sini', 'adm.onb.checking': 'Memeriksa…',
  'adm.onb.progress': '{n} dari {total} selesai',
  'adm.onb.doneTitle': 'Semua langkah selesai 🎉',
  'adm.onb.donePlatform': 'Katalog sudah punya kelas yang tayang.',
  'adm.onb.doneProvider': 'Kelas Anda sudah sampai tahap kurasi.',
  'adm.onb.doneTail': 'Panduan lengkapnya tetap bisa dibuka kapan saja lewat menu',
  'adm.onb.doneClose': 'Selesai, tutup daftar ini', 'adm.onb.doneLater': 'Nanti saja',
  'adm.onb.hideForever': 'Sembunyikan selamanya',
  'adm.onb.step.guide': 'Baca panduan singkat', 'adm.onb.step.guideDone': 'Sudah dibuka',
  'adm.onb.step.guideTodo': 'Berisi tangkapan layar tiap langkah',
  'adm.onb.step.instructor': 'Tambah pakar pengajar',
  'adm.onb.step.instructorDone': '{n} pakar terdaftar',
  'adm.onb.step.instructorTodo': 'Kelas wajib punya satu pakar',
  'adm.onb.step.course': 'Buat kelas pertama', 'adm.onb.step.courseDone': '{n} kelas dibuat',
  'adm.onb.step.courseTodo': 'Mulai dari judul & pakar pengajarnya',
  'adm.onb.step.detail': 'Isi detail & objectives', 'adm.onb.step.detailDone': 'Deskripsi & {n} objective terisi',
  'adm.onb.step.syllabus': 'Susun silabus', 'adm.onb.step.price': 'Set harga atau gratiskan',
  'adm.onb.step.priceTodo': 'Tentukan harga, atau tandai gratis',
  'adm.onb.needCourse': 'Butuh satu kelas dulu',
  'adm.onb.step.curatePlatform': 'Kurasi & terbitkan kelas',
  'adm.onb.curate.published': '{n} kelas tayang di katalog',
  'adm.onb.curate.waiting': '{n} kelas menunggu ditinjau',
  'adm.onb.curate.none': 'Belum ada kelas yang siap ditinjau',
  'adm.onb.submit.published': 'Ada kelas yang sudah tayang',
  'adm.onb.submit.waiting': 'Sedang ditinjau platform admin',
  'adm.onb.submit.todo': 'Kirim ke platform admin setelah kesiapan 4/4',

  // ---- pendapatan ----
  'adm.earn.col.order': 'Order', 'adm.earn.col.share': 'Share',
  'adm.earn.col.availableAt': 'Cair',
  'adm.earn.paid': 'Sudah dibayar',

  // ---- broadcast notifikasi ----
  'adm.bc.sub': 'Kirim pengumuman/notifikasi ke audiens terpilih. Muncul di lonceng notifikasi pengguna.',
  'adm.bc.audience': 'Audiens', 'adm.bc.kind': 'Jenis',
  'adm.bc.aud.students': 'Semua peserta', 'adm.bc.aud.providers': 'Admin provider',
  'adm.bc.aud.admins': 'Admin platform', 'adm.bc.aud.all': 'Semua pengguna',
  'adm.bc.kind.announcement': 'Pengumuman', 'adm.bc.kind.promo': 'Promo', 'adm.bc.kind.system': 'Sistem',
  'adm.bc.title': 'Judul', 'adm.bc.titlePh': 'mis. Kelas baru: Tahsin Level 2 sudah tayang!',
  'adm.bc.body': 'Isi pesan', 'adm.bc.bodyPh': 'Tulis pesan singkat & jelas…',
  'adm.bc.note': 'Dikirim langsung; tidak bisa ditarik kembali.',
  'adm.bc.send': 'Kirim broadcast', 'adm.bc.sent': '{n} notifikasi terkirim',
  'adm.bc.failed': 'Gagal mengirim',
  'adm.bc.recent': 'Notifikasi terbaru',
  'adm.bc.col.body': 'Isi', 'adm.bc.col.read': 'Dibaca',

  /* ---- akun pakar, direktori pakar & skala kategori ---- */
  'nav.profile': 'Profil Pakar',
  'nav.account': 'Akun The Muslim', 'nav.language': 'Bahasa',
  'nav.instructors': 'Pakar',
  'acc.title': 'Akun Saya',
  'acc.sub': 'Kelola profil publik dan keamanan akun Anda.',
  'acc.tab.profile': 'Profil Pakar',
  'acc.tab.security': 'Keamanan',
  'acc.save': 'Simpan profil',
  'acc.saved': 'Profil tersimpan',
  'acc.readonlyNote': 'Dikelola admin. Hubungi admin lembaga bila perlu diubah.',
  'acc.noProfile': 'Belum ada profil pakar untuk akun ini',
  'acc.noProfileHint': 'Hubungi admin lembaga Anda untuk menautkan profil.',
  'acc.field.avatar': 'Foto profil',
  'acc.field.headline': 'Headline',
  'acc.field.headlineHint': 'Satu baris bidang keahlian Anda. Maks. 160 karakter.',
  'acc.field.bio': 'Bio',
  'acc.field.bioHint': 'Latar belakang, riset, dan pengalaman Anda. Maks. 4000 karakter.',
  'acc.field.social': 'Tautan',
  'acc.field.socialHint': 'Harus diawali https://',
  'acc.social.linkedin': 'LinkedIn',
  'acc.social.web': 'Situs web',
  'acc.social.scholar': 'Google Scholar',
  'acc.social.youtube': 'YouTube',
  'acc.social.instagram': 'Instagram',
  'acc.social.x': 'X',
  'acc.field.credentials': 'Kredensial',
  'acc.cred.title': 'Judul',
  'acc.cred.issuer': 'Penerbit / detail',
  'acc.cred.year': 'Tahun',
  'acc.cred.add': 'Tambah kredensial',
  'acc.cred.remove': 'Hapus',
  'acc.cred.empty': 'Belum ada kredensial.',
  'acc.readonly.name': 'Nama',
  'acc.readonly.category': 'Bidang',
  'acc.readonly.provider': 'Lembaga',
  'acc.complete.title': 'Kelengkapan profil',
  'acc.complete.sub': 'Lengkapi semua bagian agar profil Anda siap diverifikasi admin.',
  'acc.complete.count': '{n} dari {total} selesai',
  'acc.pw.title': 'Keamanan akun',
  'acc.pw.sub': 'Password, email, dan nama Anda diurus di The Muslim — satu akun untuk semua layanan.',
  'acc.pw.manage': 'Kelola akun The Muslim',
  'acc.pw.unavailable': 'Alamat akun The Muslim belum dikonfigurasi di server ini.',
  'adm.role.instructor': 'Pakar',
  'adm.role.student': 'Peserta',
  'adm.gate.instructorSub': 'Akun pakar tidak punya akses ke portal admin. Kelola profil Anda di halaman Akun Saya.',
  'adm.gate.instructorCta': 'Ke profil saya',
  'ins.new': 'Pakar baru',
  'ins.stat.rating': 'Rating',
  'ins.stat.students': 'Peserta',
  'ins.stat.courses': 'Kelas',
  'ins.stat.answered': 'Q&A dijawab',
  'ins.coursesBy': 'Kelas oleh {name}',
  'ins.noCourses': 'Belum ada kelas',
  'ins.noCoursesHint': 'Pakar ini belum menerbitkan kelas.',
  'ins.noSlots': 'Belum ada jadwal konsultasi.',
  'ins.consultSub': 'Sesi privat via video call.',
  'insList.title': 'Pakar',
  'insList.sub': '{n} pakar terkurasi lintas bidang.',
  'insList.search': 'Cari nama atau keahlian…',
  'insList.allCategories': 'Semua bidang',
  'insList.empty': 'Pakar tidak ditemukan',
  'insList.emptyHint': 'Coba kata kunci lain atau ganti bidang.',
  'home.categoriesSub': '{n} bidang, satu standar kurasi.',
  'cat.courseCount': '{n} kelas',
  'cat.filterSearch': 'Cari bidang…',
  'cat.none': 'Bidang tidak ditemukan',
  'cat.seeAllExperts': 'Lihat semua pakar',

  // ——— kredit, bagi hasil, video pelajaran, ruang kerja pakar ———
  'vid.title': 'Video pelajaran',
  'vid.none': 'Belum ada video',
  'vid.upload': 'Unggah video',
  'vid.dropHint': 'seret berkas MP4 ke sini',
  'vid.choose': 'Pilih berkas',
  'vid.replace': 'Ganti video',
  'vid.remove': 'Hapus video',
  'vid.uploading': 'Mengunggah… {pct}%',
  'vid.finishing': 'Menyelesaikan…',
  'vid.ready': 'Video siap',
  'vid.failed': 'Unggahan gagal',
  'vid.retry': 'Coba lagi',
  'vid.cancel': 'Batalkan',
  'vid.tooLarge': 'Ukuran video maksimal 2 GB.',
  'vid.wrongType': 'Hanya berkas MP4 yang didukung.',
  'vid.slowStart': 'Video ini akan lambat mulai. Ekspor ulang dengan opsi "faststart" supaya penonton tidak menunggu.',
  'vid.durationMin': '{n} menit',
  'vid.preview': 'Putar pratinjau',
  'vid.keepTab': 'Jangan tutup tab ini sampai unggahan selesai.',
  'vid.onlyVideoLesson': 'Unggahan video hanya untuk pelajaran bertipe Video.',
  'price.credits': 'Harga (kredit)',
  'price.creditsHint': 'Harga yang dibayar murid, dalam kredit.',
  'price.compareCredits': 'Harga coret (kredit)',
  'price.locked': 'Harga terkunci',
  'price.lockedHint': 'Harga tidak bisa diubah setelah kelas diajukan atau terbit. Hubungi admin bila perlu berubah.',
  'price.creditUnit': 'kredit',
  'cur.submit': 'Ajukan kurasi',
  'cur.submitting': 'Mengirim…',
  'cur.ready': 'Siap diajukan',
  'cur.notReady': 'Belum siap diajukan',
  'cur.problems': 'Yang masih kurang',
  'cur.waiting': 'Menunggu kurasi admin',
  'cur.rejectedReason': 'Alasan dikembalikan',
  'cur.fixAndResubmit': 'Perbaiki lalu ajukan lagi.',
  'pd.title': 'Ruang kerja pakar',
  'pd.cardCourses': 'Kelas saya',
  'pd.cardStudents': 'Murid',
  'pd.cardCuration': 'Kurasi',
  'pd.published': '{n} terbit',
  'pd.draftCount': '{n} draf',
  'pd.pendingCount': '{n} menunggu',
  'pd.rejectedCount': '{n} dikembalikan',
  'pd.activeStudents': '{n} aktif',
  'pd.completedStudents': '{n} selesai',
  'pd.needsAttention': 'Perlu tindakan',
  'pd.allGood': 'Tidak ada yang perlu diperbaiki.',
  'pd.recentStudents': 'Murid terbaru',
  'pd.noStudents': 'Belum ada murid.',
  'pd.privacyNote': 'Anda melihat nama dan foto saja. Kontak murid tidak dibagikan.',
  'pd.myCourses': 'Kelas saya',
  'pd.newCourse': 'Buat kelas',
  'pd.reorder': 'Atur urutan',
  'pd.noCourses': 'Belum ada kelas',
  'pd.noCoursesHint': 'Mulai dengan membuat kelas pertama Anda.',
  'pd.videoReady': '{a}/{b} video siap',
  'pd.reason.no_lessons': 'Belum ada pelajaran',
  'pd.reason.missing_video': 'Ada pelajaran video tanpa video',
  'pd.reason.no_price': 'Harga belum ditetapkan',
  'pd.reason.rejected': 'Dikembalikan admin',
  'pd.reason.draft_stale': 'Draf lama belum diajukan',
  'wal.title': 'Dompet kredit',
  'wal.balance': 'Saldo kredit',
  'wal.withdrawable': 'Bisa dicairkan',
  'wal.topup': 'Isi kredit',
  'wal.history': 'Riwayat kredit',
  'wal.amount': 'Jumlah kredit',
  'wal.willPay': 'Yang dibayar',
  'wal.create': 'Buat tagihan',
  'wal.manualNote': 'Setelah Anda membayar, admin mengonfirmasi dan kredit masuk ke dompet.',
  'wal.empty': 'Belum ada transaksi.',
  'wal.topupsTitle': 'Tagihan top-up',
  'wal.capNote': 'Hanya kredit dari komisi yang bisa dicairkan jadi uang. Kredit hasil isi ulang dipakai untuk membeli kelas.',
  'wal.kind.topup': 'Isi kredit',
  'wal.kind.purchase': 'Pembelian kelas',
  'wal.kind.commission': 'Komisi',
  'wal.kind.withdrawal': 'Pencairan',
  'wal.kind.adjustment': 'Penyesuaian',
  'wal.kind.withdrawal_reversal': 'Pencairan dikembalikan',
  'wal.status.pending': 'Menunggu pembayaran',
  'wal.status.paid': 'Lunas',
  'wal.status.failed': 'Gagal',
  'wal.status.expired': 'Kedaluwarsa',
  'wal.currency': 'Isi kredit pakai',
  'wal.payWith': 'Penyedia pembayaran',
  'wal.channel': 'Bayar pakai',
  'wal.suggested': 'Disarankan',
  'wal.noGateway': 'Belum ada cara pembayaran yang aktif. Hubungi admin.',
  'wal.minimum': 'Minimum untuk cara ini:',
  'wal.continuePay': 'Lanjutkan bayar',
  'wal.gw.stripe': 'Kartu kredit / debit',
  'wal.gw.doku': 'QRIS, transfer & e-wallet',
  'wal.gw.manual': 'Transfer manual',
  'wal.gwHint.stripe': 'Visa, Mastercard. Ditagih dalam ringgit (MYR).',
  'wal.gwHint.doku': 'QRIS, virtual account, OVO, DANA. Ditagih dalam rupiah (IDR).',
  'wal.gwHint.manual': 'Transfer langsung, dikonfirmasi admin.',
  'wal.ret.checking': 'Pembayaran Anda sedang diperiksa. Kredit masuk otomatis setelah penyedia mengonfirmasi — biasanya kurang dari satu menit.',
  'wal.ret.paid': 'Pembayaran diterima. Kredit sudah masuk ke dompet Anda.',
  'wal.ret.cancelled': 'Pembayaran dibatalkan. Tagihannya masih tersimpan dan bisa dilanjutkan dari daftar di bawah.',
  'wal.ret.failed': 'Pembayaran tidak berhasil. Tidak ada uang yang terpotong; silakan coba lagi.',
  'aff.title': 'Afiliasi',
  'aff.code': 'Kode Anda',
  'aff.link': 'Tautan Anda',
  'aff.copy': 'Salin',
  'aff.copied': 'Tersalin',
  'aff.referred': 'Orang yang mendaftar',
  'aff.earned': 'Komisi diterima',
  'aff.pendingCredits': 'Menunggu pencairan',
  'aff.sales': 'Penjualan',
  'aff.recent': 'Komisi terbaru',
  'aff.empty': 'Belum ada komisi.',
  'aff.hint': 'Bagikan tautan ini. Orang yang mendaftar lewat tautan Anda terhubung permanen ke akun Anda.',
  'aff.permanentNote': 'Ikatan ini dipasang sekali dan tidak bisa diubah.',
  'wd.title': 'Pencairan',
  'wd.available': 'Bisa dicairkan',
  'wd.held': 'Menunggu masa tahan',
  'wd.feePct': 'Biaya {pct}%',
  'wd.net': 'Diterima',
  'wd.request': 'Ajukan pencairan',
  'wd.min': 'Minimum {n} kredit',
  'wd.method': 'Cara menerima',
  'wd.methodPh': 'Contoh: transfer BCA a.n. …',
  'wd.history': 'Riwayat pencairan',
  'wd.empty': 'Belum ada pencairan.',
  'wd.sent': 'Pengajuan pencairan terkirim',
  'wd.holdNote': 'Komisi baru bisa dicairkan setelah masa tahan lewat. Ini melindungi dari pembatalan pembayaran.',
  'wd.status.requested': 'Diajukan',
  'wd.status.approved': 'Disetujui',
  'wd.status.paid': 'Sudah dibayar',
  'wd.status.rejected': 'Ditolak',
  'wd.source.instructor': 'Komisi mengajar',
  'wd.source.affiliate': 'Komisi afiliasi',
  'wd.source.provider': 'Komisi lembaga',
  'co.payWithCredits': 'Bayar dengan kredit',
  'co.yourBalance': 'Saldo Anda',
  'co.creditWallet': 'Dompet kredit',
  'co.creditWalletNote': 'Saldo dan isi kredit diurus di akun The Muslim Anda.',
  'co.short': 'Kurang {n} kredit',
  'co.topupFirst': 'Isi kredit dulu',
  'co.paying': 'Memproses…',
  'ams.title': 'Setelan uang',
  'ams.rate': 'Kurs 1 kredit',
  'ams.currency': 'Mata uang',
  'ams.split': 'Bagi hasil',
  'ams.platform': 'The Muslim',
  'ams.provider': 'Provider',
  'ams.instructor': 'Pakar',
  'ams.affiliate': 'Afiliator',
  'ams.mustBe100': 'Total harus tepat 100%.',
  'ams.total': 'Total {n}%',
  'ams.withdrawFee': 'Biaya pencairan (%)',
  'ams.withdrawMin': 'Minimum pencairan (kredit)',
  'ams.hold': 'Masa tahan (hari)',
  'ams.vat': 'PPN',
  'ams.vatOn': 'Aktifkan PPN',
  'ams.vatPct': 'Tarif PPN (%)',
  'ams.vatPoint': 'Titik pungut',
  'ams.vatPoint.topup': 'Saat isi kredit',
  'ams.vatPoint.purchase': 'Saat beli kelas',
  'ams.vatWarn': 'PPN masih mati. Nyalakan hanya setelah tarif dan titik pungutnya dipastikan.',
  'ams.topupFee': 'Biaya top-up (%)',
  'ams.topupFeeFlat': 'Biaya tetap top-up',
  'ams.example': 'Contoh pembelian 10 kredit',
  'ams.saved': 'Setelan uang disimpan',
  'ams.ch.tab': 'Cara bayar',
  'ams.ch.name': 'Cara bayar',
  'ams.ch.gateway': 'Penyedia',
  'ams.ch.feeBps': 'Tarif (bps)',
  'ams.ch.feeFlat': 'Biaya tetap',
  'ams.ch.vat': 'Pajak (bps)',
  'ams.ch.effective': 'Berlaku',
  'ams.ch.on': 'Aktif',
  'ams.ch.off': 'Nonaktif',
  'ams.ch.noCode': 'Belum ada kode',
  'ams.ch.empty': 'Belum ada cara bayar.',
  'ams.gross': 'Bruto',
  'ams.fee': 'Biaya penyedia',
  'ams.net': 'Neto diterima',
  'ams.markPaid': 'Tandai lunas',
  'ams.payNow': 'Bayar',
  'ams.rejectWd': 'Tolak',
  'nav.wallet': 'Dompet',
  'nav.affiliate': 'Afiliasi',
  'admin.myCourses': 'Kelas Saya',
  'admin.money': 'Setelan Uang',
  'admin.topups': 'Top-up',
  'admin.withdrawals': 'Pencairan',
  'admin.workspaceOnly': 'Ruang kerja pakar',
  'adm.gate.instructorCta': 'Ke ruang kerja saya',
  'aff.haveCode': 'Punya kode afiliator?',
  'aff.enterCode': 'Masukkan kode',
  'aff.apply': 'Pasang',
  'aff.applied': 'Afiliator terpasang',
  'aff.onlyBefore': 'Kode hanya bisa dipasang sebelum pembelian pertama.',
  'aff.myReferrer': 'Afiliator Anda sudah terpasang.',

  // ---- kredit: dasbor + buku besar bagi hasil ----
  'adm.dash.creditsMonth': 'Kredit masuk bulan ini',
  'adm.dash.credits12': 'Kredit 12 bulan',
  'adm.dash.credits12sub': 'Pesanan lunas, per bulan',
  'adm.earn.sub': 'Buku besar bagi hasil, satu baris per penerima. Semua nilai dalam kredit.',
  'adm.earn.total': 'Total kredit',
  'adm.earn.col.payee': 'Penerima',
  'adm.earn.col.credits': 'Kredit',
  'adm.earn.col.payeeType': 'Peran',
  'adm.earn.payee.platform': 'Platform',
  'adm.earn.payee.provider': 'Lembaga',
  'adm.earn.payee.instructor': 'Pakar',
  'adm.earn.payee.affiliate': 'Afiliator',
  'adm.earn.legacy': '{n} baris rupiah warisan tidak ikut dijumlahkan.',
  'adm.earn.unclaimed': 'Belum berpemilik',
  // Prasyarat & jalur belajar (§21).
  'course.prereqLocked': 'Selesaikan kelas ini dulu:',
  'course.prereqAdvised': 'Disarankan selesaikan dulu:',
  'course.prereqGo': 'Buka kelas prasyarat',
  'course.path': 'Jalur belajar',
  'course.pathHint': 'Urutan yang disarankan pengajarnya.',
  'course.pathBefore': 'Sebelum ini',
  'course.pathNow': 'Kelas ini',
  'course.pathNext': 'Lanjutannya',
  'adm.course.prereq': 'Prasyarat kelas',
  'adm.course.prereqNone': 'Tanpa prasyarat',
  'adm.course.prereqHint': 'Kelas yang sebaiknya diselesaikan lebih dulu. Hanya kelas Anda sendiri.',
  'adm.course.prereqRequired': 'Wajib selesai dulu',
  'adm.course.prereqLocked': 'Murid tidak bisa membeli kelas ini sebelum lulus kelas prasyarat.',
  'adm.course.prereqAdvised': 'Hanya ditampilkan sebagai saran. Kelas tetap bisa dibeli.',
  'course.payNote': 'Dibayar dengan kredit · akses terbuka seketika',
  'adm.coupons.field.valueCredits': 'Potongan tetap (kredit)',
  'adm.coupons.field.valueCreditsHint': "Hanya dipakai kalau tipe kupon 'fixed'. Untuk 'percent', isi kolom Nilai.",

  // --- Pemberitahuan email kurasi ---
  'adm.bc.tab.send': 'Kirim siaran',
  'adm.bc.tab.email': 'Email otomatis',
  'adm.notif.smtp': 'Pengiriman email',
  'adm.notif.smtpOn': 'Siap',
  'adm.notif.smtpOff': 'Belum disetel',
  'adm.notif.smtpFrom': 'Dikirim dari {from}',
  'adm.notif.smtpHint': 'Kredensial SMTP belum diisi di server, jadi email tidak akan terkirim walau daftar di bawah sudah diisi. Isi SMTP_HOST dan SMTP_FROM di berkas .env server.',
  'adm.notif.curation': 'Beri tahu lewat email saat ada kelas diajukan kurasi',
  'adm.notif.curationHint': 'Notifikasi di dalam panel tetap dibuat walau ini dimatikan. Yang ini menambah email, supaya antrean kurasi tidak menumpuk hanya karena tidak ada yang membuka panel.',
  'adm.notif.recipients': 'Alamat penerima',
  'adm.notif.addEmail': 'Tambah alamat',
  'adm.notif.removeEmail': 'Hapus alamat',
  'adm.notif.noRecipients': 'Belum ada alamat. Tanpa satu pun penerima, tidak ada email yang bisa dikirim.',
  'adm.notif.decision': 'Beri tahu pakar saat kelasnya disetujui atau ditolak',
  'adm.notif.decisionHint': 'Dikirim ke email akun pakar pemilik kelas. Untuk yang ditolak, alasannya ikut disertakan.',
  'adm.notif.save': 'Simpan setelan',
  'adm.notif.test': 'Kirim email percobaan',
  'adm.notif.testSent': 'Email percobaan terkirim ke {n} alamat.',
  'adm.notif.testFailed': 'Email percobaan gagal dikirim.',
}
